import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

/**
 * NavbarBrand - A className-based implementation that matches the Bulma NavbarBrand
 * 
 * This component provides the same API as Bloomer's NavbarBrand for easy migration
 */
const NavbarBrand = ({
  children,
  className,
  ...rest
}) => {
  const navbarBrandClasses = classNames('navbar-brand', {
    [className]: className,
  });

  return (
    <div className={navbarBrandClasses} {...rest}>
      {children}
    </div>
  );
};

NavbarBrand.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

NavbarBrand.defaultProps = {
  children: null,
  className: '',
};

export default NavbarBrand;
